// import './wdyr'; // <--- first import

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { bootstrap } from './bootstrap';
import posthog from 'posthog-js';
import { PostHogProvider} from 'posthog-js/react'

const posthogOptions = {
  api_host: 'https://ph.journey.io',
  ui_host: 'https://us.i.posthog.com',
  disable_session_recording: true,
  // autocapture: false
};

if(process.env.NODE_ENV === 'production'){
  posthog.init(
    'phc_lVVEvWQ9ipWCFc2hrsKVkz3ycNUH1kzsYjhBfhmLyTy',
    posthogOptions
  );
}


bootstrap();
ReactDOM.render(
  <React.StrictMode>
      <PostHogProvider
            client={posthog}
          >
          <App/>
      </PostHogProvider>    
  </React.StrictMode>,
  document.getElementById('root')
);
